/**
 * Google Ads Conversion-Tracking (03.11.2026, Konto 105-362-7131, Tag AW-361696847).
 * Lädt den Google-Tag ERST nach Zustimmung zu „Marketing“ (Consent Mode v2, Basis-Variante: vorher keine Verbindung zu Google).
 * Team-Geräte (kmg_intern_v1) zählen nie.
 */
export const ADS_TAG = "AW-361696847";
export const ADS = { kauf: "AW-361696847/jyBtCJHk_LAdEM-cvKwB", anfrage: "AW-361696847/BRwHCIvx_LAdEM-cvKwB" };

export function loadGoogleAds() {
  if (typeof window === "undefined" || window.__adsOk) return;
  window.__adsOk = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "denied" });
  window.gtag("consent", "update", { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted", analytics_storage: "denied" });
  window.gtag("js", new Date());
  window.gtag("config", ADS_TAG);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_TAG}`;
  document.head.appendChild(s);
}

export function revokeGoogleAds() {
  if (typeof window === "undefined" || !window.gtag) return;
  try { window.gtag("consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" }); } catch { /* noop */ }
  window.__adsOk = false;
}

/** kind: "kauf" | "anfrage". Ohne Marketing-Zustimmung passiert nichts. */
export function adsConversion(kind, { value, transactionId } = {}) {
  try {
    if (!window.__adsOk || !window.gtag || !ADS[kind]) return false;
    if (transactionId) {
      const k = `fbv_ads_${kind}_${transactionId}`;
      if (sessionStorage.getItem(k)) return false;   // beim Neuladen nicht doppelt
      sessionStorage.setItem(k, "1");
    }
    window.gtag("event", "conversion", {
      send_to: ADS[kind], value: Number(value) > 0 ? Math.round(Number(value) * 100) / 100 : 1.0, currency: "EUR",
      ...(transactionId ? { transaction_id: String(transactionId) } : {}),
    });
    return true;
  } catch { return false; }
}
